import { IWarehouseRepository } from '@/repository/warehouse/WarehouseRepository.types'

import Api from '@/repository/api'
import {Warehouse, WarehouseItem, WarehouseAddRequestType, WarehouseUpdateRequestType} from '@/entity/warehouse/Warehouse'
import {
    IWarehouse,
    WarehouseResponseType,
    IWarehouseItem,
    WarehouseItemResponseType,

} from '@/entity/warehouse/Warehouse.types'

import { PaginationRequestType } from "@/entity/common/pagination.types";
import { ResponseDataType } from "@/form/form.types";

import qs from "qs";

export class WarehouseRepository implements IWarehouseRepository {
    async fetchAll(data?: FormData): Promise<IWarehouse> {
        const response = await Api.get('/store/get',{params: data, paramsSerializer: function paramsSerializer(params) {
                return new URLSearchParams(params).toString()
        }});

        const responseData = response.data as WarehouseResponseType;
        return new Warehouse(responseData)
        //return respData.map((role: StoreResponseType) => new warehouse(respData));
    }
    async fetchData(data: PaginationRequestType): Promise<IWarehouseItem> {
        
        const response = await Api.get(`/store/get`, {params: data, paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, {arrayFormat: 'repeat'})
            }});
        //const responseData = response.data as StoreItemResponseType;
        const responseData = response.data as WarehouseResponseType;
        //return new StoreItem(responseData).data[0];
        return new Warehouse(responseData).data[0];
    }
    async create(data: WarehouseAddRequestType): Promise<ResponseDataType> {
        const res = await Api.post('/store/create', data);
        return res.data;
    }
    async update(data: WarehouseUpdateRequestType): Promise<ResponseDataType> {
        console.log('WarehouseRepository - '+data);
        const res = await Api.post('/store/update', data);
        return res.data;
    }
    async delete(data: {id: number}): Promise<ResponseDataType> {
        const res = await Api.post('/store/delete', data);
        return res.data;
    }
    
}
